// What a quick input's reading (quickParse.parseQuickInput / taskText.parseTaskText) sets on a
// new task, the same in New, on Home, in a table's add row and in the desktop panel. A bot
// named with "@" takes the task after it exists (PUT /tasks/:id/bot, botOf).

/** The task fields the reading gives: project, list, labels, priority, length, person, repeat, day and time. */
export function taskFields(read, { toLocalDateString, toUTCISO } = {}) {
  const data = {};
  if (read.project) data.project_id = read.project.id;
  if (read.section) data.section_id = read.section.id;
  if (read.labels?.length) data.label_ids = read.labels.map((l) => l.id);
  if (read.priority) data.priority = read.priority;
  if (read.duration) data.duration = read.duration;
  if (read.person?.user_id) data.assigned_to = [read.person.user_id];
  if (read.recurrence) data.recurrence = read.recurrence;
  if (read.date && toLocalDateString) data.due_date = toLocalDateString(read.date);
  if (read.time && read.date) {
    // A time puts it in the calendar (unless that time is gone).
    data.due_time = read.time;
    const start = new Date(read.date);
    const [h, m] = read.time.split(':').map(Number);
    start.setHours(h, m, 0, 0);
    if (start > new Date() && toUTCISO) {
      data.scheduled_start = toUTCISO(start);
      data.scheduled_end = toUTCISO(new Date(start.getTime() + (read.duration || 60) * 60000));
    }
  }
  return data;
}

/** The bot a reading hands the task to ("@Copywriter"), if any. */
export const botOf = (read) => read.person?.bot_id || null;

/** Who "@" can name for a task in this project: its team's people and the bots that may work
 * on it (the team's bots and the person's own; outside a team, the person's own bots). */
export function botsFor(project, mine, userId) {
  return (mine?.bots || [])
    .filter((b) => b && !b.queen && !b.deleted_at && (
      (project?.team_id && b.owner_type === 'team' && b.owner_id === project.team_id)
      || (b.owner_type === 'user' && b.owner_id === userId)))
    .map((b) => ({ bot_id: b.id, name: b.name, bot: b }));
}

/** The labels "+" offers and reads: one per name. GET /labels returns every teammate's labels
 * too, so five people's "Urgent" came five times; the person's own label wins, else the first. */
export function uniqueLabels(labels, userId) {
  const byName = new Map();
  (labels || []).forEach((l) => {
    if (!l?.name || l.deleted_at) return;
    const key = l.name.trim().toLocaleLowerCase();
    const had = byName.get(key);
    if (!had || (had.user_id !== userId && l.user_id === userId)) byName.set(key, l);
  });
  return [...byName.values()];
}
